"use strict";

!(function ($) {
  let instafeedInited = false
  if ($(".slider_block_inner").length) {
    $(".slider_block_inner").slick({
      centerMode: true,
      arrows: true,
      dots: false,
      slidesToShow: 1,
      speed: 500,
      fade: true,
      cssEase: "linear",
    });
  }
  function mobile_only_carousel() {
    if ($(".bottom_block_carousel").length) {
      if ($(window).width() <= 767.98) {
        $(".bottom_block_carousel").slick({
          arrows: false,
          dots: true,
          slidesToShow: 1,
          adaptiveHeight: true,
        });
      } else {
        $(".bottom_block_carousel").slick("unslick");
      }
    }
    if ($("#insta-feed").length) {
      if ($(window).width() <= 767.98) {
        console.log('init feed slider!')
        $("#insta-feed").slick({
          arrows: false,
          dots: true,
          slidesToShow: 1,
          adaptiveHeight: true,
        });
        instafeedInited = true
      } else {
        console.log('unslick feed slider!')
        $("#insta-feed").slick("unslick");
      }
    }
  }
  mobile_only_carousel();
  $(window).resize(function () {
    mobile_only_carousel();
  });
  if( $('.insta-feed-section').length ) {
    $(document).on('DOMNodeInserted', function(e) {
      if( $('.insta-feed-section').find('#insta-feed').length && !instafeedInited ) {
        mobile_only_carousel();
      }
    });
  }
})(jQuery);
